// useUtmTracking.js
import { useEffect } from 'react';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'utm_params';

export function captureUtmParams() {
    const params = new URLSearchParams(window.location.search);
    const utmData = {};

    UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) utmData[key] = value;
    });

    if (Object.keys(utmData).length > 0) {
        // Persist for the session so later pages/forms can still access it
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
        return utmData;
    }

    // Fallback: no new UTMs in URL, return whatever was already stored
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
}

export function getStoredUtmParams() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
}

export function useUtmTracking() {
    useEffect(() => {
        const utmData = captureUtmParams();

        if (utmData) {
            // Push to GTM/GA4 dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'utm_capture',
                ...utmData,
            });
        }
    }, []);
}